export const cleanNumbers = (input) => {
  if (!input) {
    return;
  }

  return Number(input.replace(/[^\d.-]/g, ""));
};

export const parseBoolean = function (string) {
  var bool;
  bool = (function () {
    switch (false) {
      case string.toLowerCase() !== "true":
        return true;
      case string.toLowerCase() !== "false":
        return false;
    }
  })();
  if (typeof bool === "boolean") {
    return bool;
  }
  return void 0;
};

export const getExtFromIntervalText = function (string, paranthesis) {
  if (!string || typeof string != "string") {
    return "";
  }

  const regex1 = /[-]{0,1}[\d]*[.]*[,]{0,1}[\d]+/g;
  const regex2 = /[^a-z]/gi;

  var ext = string.trim().replace(regex1, "").replace(regex2, "");

  if (paranthesis) {
    ext = "(" + ext + ")";
  }

  return ext;
};
